/**
 * 레기온
 */
import { useMemo, Fragment } from 'react';
import { useLoaderData } from 'react-router-dom';
import Header from '@features/content/Header';
import { apiSearchSlice } from '@features/api/apiSearchSlice';
import { setRequestToSearchParams } from '@utils/index';
import { ALIAS, CUR_NETWORK, FILTER_DATA, NETWORK, SEARCH_PARAMS } from '@constants/index';
import { getLocalData } from '@features/api/apiLocalSlice';
import NoData from '../../components/contents/common/NoData';
import { useOption } from '@hooks/useOption';
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import { selectL10N, setAlias } from '@features/ui/UiSlice';
import FilterWrap from '@components/contents/common/FilterWrap';
import LegionArticle from '@components/contents/article/LegionArticle';
import Paging from '@components/contents/common/Paging';
import type { IContentData, ILegion, ILoaderData, l10nFilterType } from '@type/index';

export const LegionLoader =
  (dispatch, option: IOption) =>
  async ({ request }): Promise<ILegion | null> => {
    const searchParams = setRequestToSearchParams(request);

    // alias 변경 - searchParams 변경에 사용됨
    dispatch(setAlias(ALIAS.LEGION));

    if (!searchParams?.keyword) {
      return null;
    }

    console.log('searchParams', searchParams);

    for (let key in searchParams) {
      !searchParams[key] && delete searchParams[key]; // serverId 등 string으로 보내면 안됨
    }

    return CUR_NETWORK === NETWORK.OPDEV
      ? await getLocalData(ALIAS.LEGION, searchParams)
      : await dispatch(apiSearchSlice?.endpoints?.getGuild?.initiate({ option, params: searchParams }));
  };

const setFilterData = (option: IOption) => {
  const { serviceAlias, serverData } = option || {};

  if (!serviceAlias) {
    return {};
  }

  const filterData = FILTER_DATA[serviceAlias][ALIAS.LEGION];
  let newServerIdData = [...filterData[SEARCH_PARAMS.SERVER_ID]] as l10nFilterType;

  if (Array.isArray(serverData) && serverData?.length > 0) {
    serverData?.forEach((v) => {
      const { serverId, serverName } = v || {};
      newServerIdData?.push({
        title: serverName,
        value: serverId,
      });
    });
  }

  return {
    ...filterData,
    [SEARCH_PARAMS.SERVER_ID]: newServerIdData,
  };
};

interface IFilterComponentProps {
  count: number;
}
const FilterComponent = ({ count }: IFilterComponentProps) => {
  const option = useOption();

  const filterDataObj = useMemo(() => setFilterData(option), []);

  return (
    <Header totalCount={count}>
      <FilterWrap filterDataObj={filterDataObj} />
    </Header>
  );
};

interface IContentComponentProps {
  data: IContentData<ILegion>;
}
const ContentComponent = ({ data }: IContentComponentProps) => {
  const l10n = useAppSelector(selectL10N);

  return (
    <Fragment>
      <div className="search-content">
        <ul className="column column-2">
          {data?.list.map((item, i) => (
            <li key={i} className="search-item">
              <LegionArticle item={item} l10n={l10n!} />
            </li>
          ))}
        </ul>
      </div>
      <Paging endPage={data?.pagination?.endPage} showPage={5} l10n={l10n!} />
    </Fragment>
  );
};

const Legion = () => {
  const { data, isLoading, isError } = (useLoaderData() as ILoaderData<IContentData<ILegion>>) || {};

  console.log('Legion Data', data);

  return (
    <div className="search-result legions">
      <FilterComponent count={data?.pagination?.total} />
      {!isError && Array.isArray(data?.list) && data?.list?.length > 0 ? <ContentComponent data={data} /> : <NoData />}
    </div>
  );
};

export default Legion;
